export const SelectorUtil = {
	closest: function(elem, selector){
		if(elem.closest) return elem.closest(selector);
		else{
			let el = elem;
		    while (el) {
		        if (this.matches(el, selector)) {
		            return el;
		        }
		        el = el.parentElement;
		    }
		}
	},

	matches: function(elem, selector){
		if (elem.matches) return elem.matches(selector);
		else if(elem.matchesSelector) return elem.matchesSelector(selector);
		else if(elem.mozMatchesSelector) return elem.mozMatchesSelector(selector);
		else if(elem.msMatchesSelector) return elem.msMatchesSelector(selector);
		else if(elem.oMatchesSelector) return elem.oMatchesSelector(selector);
		else if(elem.webkitMatchesSelector) return elem.webkitMatchesSelector(selector);
		else return (function(s) {
            let matches = (document || elem.ownerDocument).querySelectorAll(s),
                i = matches.length;
            while (--i >= 0 && matches.item(i) !== elem) {}
            return i > -1;            
        })(selector);
	}
}